import { AdditionalItemForPrescriptionReleaseStruct } from "../../structs/pharmacy/additional-item-for-prescription-release.struct";
import { AdditionalMedicineForPrescriptionReleaseStruct } from "../../structs/pharmacy/additional-medicine-for-prescription-release.struct";
import { PrescriptionNonDispensationRequest } from "../medical-record/prescription-non-dispensation.request";
import { LiberatePrescriptionRequest } from "./liberate-prescription.request";

export class LiberateSolutionPrescriptionRequest {
    public listLiberatePrescription: LiberatePrescriptionRequest[] = [];
    public listPrescriptionNonDispensationRequest: PrescriptionNonDispensationRequest[] = [];
    public listAdditionalItemForPrescriptionRelease: AdditionalItemForPrescriptionReleaseStruct[] = [];   
    public listAdditionalMedicineForPrescriptionRelease: AdditionalMedicineForPrescriptionReleaseStruct[] = [];   
    
    public listIdKit: number[] = [];
}